import { ENDPOINTS } from '../constants/endpoints'
import type { AxiosResponse } from 'axios'
import type {
  Church,
  ChurchCreateInput,
  ChurchUpdateInput,
} from '../types/church'
import axiosInstance from '@/integrations/axios/axios-instance'

export const churchesApi = {
  getChurches: (): Promise<AxiosResponse<{ churches: Array<Church> }>> => {
    const endpoint = ENDPOINTS.GET_CHURCHES
    return axiosInstance.get(endpoint)
  },
  getPublicChurches: (): Promise<AxiosResponse<{ churches: Array<Church> }>> => {
    const endpoint = `${ENDPOINTS.GET_CHURCHES}public`
    return axiosInstance.get(endpoint)
  },
  getChurch: (churchId: string): Promise<AxiosResponse<{ church: Church }>> => {
    const endpoint = `${ENDPOINTS.GET_CHURCH}/${churchId}`
    return axiosInstance.get(endpoint)
  },
  createChurch: (
    church: ChurchCreateInput,
  ): Promise<AxiosResponse<{ message: string; church: Church }>> => {
    const endpoint = ENDPOINTS.CREATE_CHURCH
    return axiosInstance.post(endpoint, church)
  },
  updateChurch: (
    church: ChurchUpdateInput,
  ): Promise<AxiosResponse<{ message: string; church: Church }>> => {
    const endpoint = `${ENDPOINTS.UPDATE_CHURCH}/${church._id}`
    return axiosInstance.put(endpoint, church)
  },
  deleteChurch: (
    churchId: string,
  ): Promise<AxiosResponse<{ message: string; id: string }>> => {
    const endpoint = `${ENDPOINTS.DELETE_CHURCH}/${churchId}`
    return axiosInstance.delete(endpoint)
  },
}
